// frontend/src/services/cmsService.js
import api from './api';

export const cmsService = {
  getSettings: () => api.get('/cms/settings/get_settings/'),
  getMenus: (position = 'header') => api.get(`/cms/menus/?position=${position}`),
  getPageBySlug: (slug) => api.get(`/cms/pages/${slug}/`),
  getFooter: () => api.get('/cms/footer/get_footer/'),
  getBanners: (position) => api.get(`/cms/banners/?position=${position}`),
};
export const getSEOSettings = async () => {
  try {
    const response = await api.get('/cms/settings/seo_settings/');
    return response.data;
  } catch (error) {
    console.error('Error fetching SEO settings:', error);
    // مقدار پیش‌فرض در صورت خطا
    return { block_search_engines: true };
  }
};

export const updateSEOSettings = async (data) => {
  const response = await api.post('/cms/settings/seo_settings/', data);
  return response.data;
};